<app-nav></app-nav>
<section class="login-section set-profile">
  <div class="container">
    <div class="product-container">
      <div class="product-inner">
        
        <form name="form" (ngSubmit)="f.form.valid" #f="ngForm" >
          <span class="alreadyRegError" ng-bind-html="alreadyRegError"></span>
          <div class="reg1" *ngIf="!showAddFamily">
              <h2>Profile</h2>
          <div class="form-group">
            <input type="text" class="form-control" name="name" id="name" placeholder="Name" #name="ngModel" [(ngModel)]="data.name" value="{{profileName}}" required>
          </div>
          <div class="input-group mb-3 input-mobile">
            <div class="input-group-prepend">
              <span class="input-group-text">+91</span>
            </div>
              <input type="text" #mobile="ngModel" name="mobile" id="mobile" class="form-control" placeholder="9999999999" (keypress)="keyPress($event)" minlength=10 maxlength=10 [(ngModel)]="data.mobile" value="{{profileContactNo}}" required>
          </div>
          <div class="form-group">
            <input type="email" class="form-control" name="email" id="email" placeholder="Email" #email="ngModel" [(ngModel)]="data.email" value="{{profileEmail}}" required>
          </div>
          <div class="input-group">
            <div class="input-group addon">
              <p-calendar class="dob-calendar" [touchUI]="true" [readonlyInput]="true" name="dob" id="dob" placeholder="Date of Birth" #dob="ngModel" [(ngModel)]="data.dob" value="{{profileDob}}" dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:2020" required></p-calendar>
            </div>
          </div>
          <!-- <div class="form-group">
            <input type="date" class="form-control dateclass placeholderclass" name="dob" id="dob" placeholder="Date of Birth" #dob="ngModel" [(ngModel)]="data.dob" value="{{profileDob}}" required>
          </div> -->
          <div class="form-group">
            <input type="text" class="form-control" name="company" id="company" placeholder="Company" #company="ngModel" [(ngModel)]="data.company" value="{{profileCompany}}" required>
          </div>
          <div class="form-group">
              <span [innerHtml]="error" class="error"></span>
          </div>
          
          <div class="row top-gap-lg">
              <div class="col">
                <button class="btn btn-submit btn-primary" (click)="showAddFamilyFunc()">Add Family</button>
              </div>
              <div class="col">
                <button class="btn btn-submit btn-primary" type="submit" [disabled]="f.form.invalid" (click)="setProfileDetails()">Submit</button>
              </div>
          </div>
        </div>
        <div class="reg2" *ngIf="showAddFamily">
          <!-- Add Family -->
          <h2>Add Family</h2>
          <div class="form-group">
              <select class="form-control" name="relation" id="relation" [(ngModel)]="familyMemberRelation">
                <option value="undefined" selected disabled>Relation</option>
                <option value="Father">Father</option>
                <option value="Mother">Mother</option>
                <option value="Husband">Husband</option>
                <option value="Wife">Wife</option>
                <option value="Son">Son</option>
                <option value="Daughter">Daughter</option>
              </select>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" name="name" id="name" placeholder="Name" [(ngModel)]="familyMemberName">
            </div>
            <div class="input-group">
              <div class="input-group addon">
                <p-calendar class="dob-calendar" [touchUI]="true" [readonlyInput]="true" name="member-dob" id="member-dob" placeholder="Date of Birth" [(ngModel)]="familyMemberDob" dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1960:2020"></p-calendar>
              </div>
            </div>
            
            <div class="row top-gap-lg">
                <div class="col">
                  <button class="btn btn-submit btn-primary" (click)="backToReg()">Back</button>
                </div>
                <div class="col">
                  <button class="btn btn-submit btn-primary" type="submit" [disabled]="f.form.invalid" (click)="setProfileDetails()">Submit</button>
                </div>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</section>